"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var Comparator = _interopRequireWildcard(require("../comparison"));

var _const = require("../const");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var legalComparators = [Comparator.EQ, Comparator.NE, Comparator.GT, Comparator.GE, Comparator.LT, Comparator.LE];

function dateParser(d) {
  return "".concat(d.getUTCFullYear(), "-").concat(('0' + (d.getUTCMonth() + 1)).slice(-2), "-").concat(('0' + d.getUTCDate()).slice(-2));
}

var DateFilter = /*#__PURE__*/function (_Component) {
  _inherits(DateFilter, _Component);

  var _super = _createSuper(DateFilter);

  function DateFilter(props) {
    var _this;

    _classCallCheck(this, DateFilter);

    _this = _super.call(this, props);
    _this.timeout = null;
    _this.comparators = props.comparators || legalComparators;
    _this.applyFilter = _this.applyFilter.bind(_assertThisInitialized(_this));
    _this.onChangeDate = _this.onChangeDate.bind(_assertThisInitialized(_this));
    _this.onChangeComparator = _this.onChangeComparator.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DateFilter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var getFilter = this.props.getFilter;
      var comparator = this.dateFilterComparator.value;
      var date = this.inputDate.value;

      if (comparator && date) {
        this.applyFilter(date, comparator, true);
      } // export onFilter function to allow users to access


      if (getFilter) {
        getFilter(function (filterVal) {
          var nullableFilterVal = filterVal || {
            date: null,
            comparator: null
          };
          _this2.dateFilterComparator.value = nullableFilterVal.comparator;
          _this2.inputDate.value = nullableFilterVal.date ? dateParser(nullableFilterVal.date) : null;

          _this2.applyFilter(nullableFilterVal.date, nullableFilterVal.comparator);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timeout) clearTimeout(this.timeout);
    }
  }, {
    key: "onChangeDate",
    value: function onChangeDate(e) {
      var comparator = this.dateFilterComparator.value;
      var filterValue = e.target.value;
      this.applyFilter(filterValue, comparator);
    }
  }, {
    key: "onChangeComparator",
    value: function onChangeComparator(e) {
      var value = this.inputDate.value;
      var comparator = e.target.value;
      this.applyFilter(value, comparator);
    }
  }, {
    key: "getComparatorOptions",
    value: function getComparatorOptions() {
      var optionTags = [];
      var withoutEmptyComparatorOption = this.props.withoutEmptyComparatorOption;

      if (!withoutEmptyComparatorOption) {
        optionTags.push( /*#__PURE__*/_react["default"].createElement("option", {
          key: "-1"
        }));
      }

      for (var i = 0; i < this.comparators.length; i += 1) {
        optionTags.push( /*#__PURE__*/_react["default"].createElement("option", {
          key: i,
          value: this.comparators[i]
        }, this.comparators[i]));
      }

      return optionTags;
    }
  }, {
    key: "getDefaultComparator",
    value: function getDefaultComparator() {
      var _this$props = this.props,
          defaultValue = _this$props.defaultValue,
          filterState = _this$props.filterState;

      if (filterState && filterState.filterVal) {
        return filterState.filterVal.comparator;
      }

      if (defaultValue && defaultValue.comparator) {
        return defaultValue.comparator;
      }

      return '';
    }
  }, {
    key: "getDefaultDate",
    value: function getDefaultDate() {
      // Set the appropriate format for the input type=date, i.e. "YYYY-MM-DD"
      var _this$props2 = this.props,
          defaultValue = _this$props2.defaultValue,
          filterState = _this$props2.filterState;

      if (filterState && filterState.filterVal && filterState.filterVal.date) {
        return dateParser(filterState.filterVal.date);
      }

      if (defaultValue && defaultValue.date) {
        return dateParser(new Date(defaultValue.date));
      }

      return '';
    }
  }, {
    key: "applyFilter",
    value: function applyFilter(value, comparator, isInitial) {
      // if (!comparator || !value) {
      //  return;
      // }
      var _this$props3 = this.props,
          column = _this$props3.column,
          onFilter = _this$props3.onFilter,
          delay = _this$props3.delay;

      var execute = function execute() {
        // Incoming value should always be a string, and the defaultDate
        // above is implemented as an empty string, so we can just check for that.
        // instead of parsing an invalid Date. The filter function will interpret
        // null as an empty date field
        var date = value === '' ? null : new Date(value);
        onFilter(column, _const.FILTER_TYPE.DATE, isInitial)({
          date: date,
          comparator: comparator
        });
      };

      if (delay) {
        this.timeout = setTimeout(function () {
          execute();
        }, delay);
      } else {
        execute();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          id = _this$props4.id,
          placeholder = _this$props4.placeholder,
          _this$props4$column = _this$props4.column,
          dataField = _this$props4$column.dataField,
          text = _this$props4$column.text,
          style = _this$props4.style,
          comparatorStyle = _this$props4.comparatorStyle,
          dateStyle = _this$props4.dateStyle,
          className = _this$props4.className,
          comparatorClassName = _this$props4.comparatorClassName,
          dateClassName = _this$props4.dateClassName;
      var comparatorElmId = "date-filter-comparator-".concat(dataField).concat(id ? "-".concat(id) : '');
      var inputElmId = "date-filter-column-".concat(dataField).concat(id ? "-".concat(id) : '');
      return /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        className: "filter date-filter ".concat(className),
        style: style
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "filter-label",
        htmlFor: comparatorElmId
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "sr-only"
      }, "Filter comparator"), /*#__PURE__*/_react["default"].createElement("select", {
        ref: function ref(n) {
          return _this3.dateFilterComparator = n;
        },
        id: comparatorElmId,
        style: comparatorStyle,
        className: "date-filter-comparator form-control ".concat(comparatorClassName),
        onChange: this.onChangeComparator,
        defaultValue: this.getDefaultComparator()
      }, this.getComparatorOptions())), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: inputElmId
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "sr-only"
      }, "Enter $", text), /*#__PURE__*/_react["default"].createElement("input", {
        ref: function ref(n) {
          return _this3.inputDate = n;
        },
        id: inputElmId,
        className: "filter date-filter-input form-control ".concat(dateClassName),
        style: dateStyle,
        type: "date",
        onChange: this.onChangeDate,
        placeholder: placeholder || "Enter ".concat(text, "..."),
        defaultValue: this.getDefaultDate()
      })));
    }
  }]);

  return DateFilter;
}(_react.Component);

DateFilter.propTypes = {
  onFilter: _propTypes.PropTypes.func.isRequired,
  column: _propTypes.PropTypes.object.isRequired,
  id: _propTypes.PropTypes.string,
  filterState: _propTypes.PropTypes.object,
  delay: _propTypes.PropTypes.number,
  defaultValue: _propTypes.PropTypes.shape({
    date: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.object]),
    comparator: _propTypes.PropTypes.oneOf([].concat(legalComparators, ['']))
  }),

  /* eslint consistent-return: 0 */
  comparators: function comparators(props, propName) {
    if (!props[propName]) {
      return;
    }

    for (var i = 0; i < props[propName].length; i += 1) {
      var comparatorIsValid = false;

      for (var j = 0; j < legalComparators.length; j += 1) {
        if (legalComparators[j] === props[propName][i] || props[propName][i] === '') {
          comparatorIsValid = true;
          break;
        }
      }

      if (!comparatorIsValid) {
        return new Error("Date comparator provided is not supported.\n          Use only ".concat(legalComparators));
      }
    }
  },
  placeholder: _propTypes.PropTypes.string,
  withoutEmptyComparatorOption: _propTypes.PropTypes.bool,
  style: _propTypes.PropTypes.object,
  comparatorStyle: _propTypes.PropTypes.object,
  dateStyle: _propTypes.PropTypes.object,
  className: _propTypes.PropTypes.string,
  comparatorClassName: _propTypes.PropTypes.string,
  dateClassName: _propTypes.PropTypes.string,
  getFilter: _propTypes.PropTypes.func
};
DateFilter.defaultProps = {
  delay: 0,
  defaultValue: {
    date: undefined,
    comparator: ''
  },
  filterState: {},
  withoutEmptyComparatorOption: false,
  comparators: legalComparators,
  placeholder: undefined,
  style: undefined,
  className: '',
  comparatorStyle: undefined,
  comparatorClassName: '',
  dateStyle: undefined,
  dateClassName: '',
  id: null
};
var _default = DateFilter;
exports["default"] = _default;